import 'es6-promise/auto'
import Vue from 'vue'
import Router from 'vue-router'
import Full from '../containers/Full';
import verification from '../views/verification';
import PagenotFound from '../views/pages/Page404';
import ResetPassword from '../views/pages/ResetPassword';
import Login from '../views/pages/Login';
import Register from '../views/pages/Register';
import AfterRegister from '../views/pages/AfterRegister';
import Dashboard from '../views/Dashboard';
import AdminDashboard from '../views/AdminDashboard';
import Registration from '../views/Registration';
import Shop from '../views/setting/Shop';
import Role from '../views/setting/Role';
import User from '../views/setting/User';
import Help from '../views/help';

//purchase
import addpurches from '../views/purches/addpurches';
import editpurchase from '../views/purches/editpurchase';
import Listpurches from '../views/purches/listpurches';
import Listpurchesreturn from '../views/purches/Listpurchesreturn';
import Addpurchesreturn from '../views/purches/Addpurchesreturn';
import editpurchasereturn from '../views/purches/editpurchasereturn';
import AddSupplier from '../views/purches/Supplier';
import addpayment from '../views/purches/Purchasepayment';
import purchase_payment_history from '../views/purches/purchasepaymenthistory';
import purchasereturn_pending_list from '../views/purches/PurchaseReturnpayment';

//sales
import sales from '../views/sales/sales';
import addsales from '../views/sales/addsales';
import editsales from '../views/sales/editsales';
import ListSalesrt from '../views/sales/list';
import salesreturn from '../views/sales/salesreturn';
import editsalesreturn from '../views/sales/editsalesreturn';
import Customer from '../views/setting/Customer';
import saleinvoice from '../views/sales/saleinvoice';
import salepdf from '../views/sales/salepdf';
import salepayment from '../views/sales/salepayment';
import salepaymenthistory from '../views/sales/salepaymenthistory';
import salereturnpayment from '../views/sales/salereturnpayment'

//single linkns
import ShopInventory from '../views/ShopInventory';
import Listtransfer from '../views/transfer/listtransfer';
import addtransfer from '../views/transfer/addtransfer';

//setup
import addproduct from '../views/product/addproduct';
import barcode from '../views/product/barcode';
import Category from '../views/setting/Category';
import Brand from '../views/setting/Brand';
import hsn from '../views/setting/HSN';
import hsnrate from '../views/setting/Hsnrate';
import variant from '../views/setting/variant';
import unit from '../views/setting/unit';

//admin pages
import company_mgmt from '../views/admin_pages/company_mgmt';
import user_info from '../views/admin_pages/user_mgmt';
import user_status from '../views/admin_pages/user_status_info';
import plan_config from '../views/admin_pages/plan_config';

//reports
import pending_payment_cust_list from '../views/reports/sales/pending_pay_list';
import pending_payment_supp_list from '../views/reports/purchase/pending_pay_list.vue';
//auth checker
import store from '../store'


Vue.use(Router)

function doSomethingBeforeAllChildren(ax) {
}

export default new Router({
  hashbang: false,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '*', component: PagenotFound },
    {
      path: '/verifyemail/:uid',
      beforeEnter: (to, from, next) => {
        let uid = to.params.uid;
        localStorage.clear();
        store.commit('SET_AUTH_USER', null)
        next({ path: '/', query: { id: uid } })
      }
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!store.state.userStore.authUser || store.state.userStore.authUser === 'null' || localStorage.getItem('authUser') == null) {
          next();
        } else {
          next('/dashboard');
        }
      },
    },

    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        if (!store.state.userStore.authUser || store.state.userStore.authUser === 'null' || localStorage.getItem('authUser') == null) {
          next();
        } else {
          next('/dashboard');
        }
      },
    },
    {
      name: 'Sale Invoice Pdf',
      path: '/saleinvoice/saleinvoicepdf',
      component: salepdf,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        // var roles = JSON.parse(localStorage.getItem('roles'))
        // if(roles[8].view === true){
        // var saleinvoice_view = store.state.saleinvoice_view
        // if(saleinvoice_view === true){
        next()
        // }else{
        //   next('/dashboard');
        // }
      },
    },
    {
      path: '/afterregister',
      name: 'AfterRegister',
      component: AfterRegister,
      beforeEnter: (to, from, next) => {
        if (!store.state.userStore.authUser || store.state.userStore.authUser === 'null') {
          next();
        } else {
          next('/dashboard');
        }
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      beforeEnter: (to, from, next) => {
        if (!store.state.userStore.authUser || store.state.userStore.authUser === 'null') {
          next();
        } else {
          next('/dashboard');
        }
      },
    },

    {
      path: '/authuser',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      meta: { requiresAuth: true },
      children: [
        // Dashboard
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            var is_admin = store.state.is_admin
            if (is_admin === true) {
              next('/admindashboard');
            } else {
              next()
            }
          },
        },

        {
          path: '/admindashboard',
          name: 'Admin Dashboard',
          component: AdminDashboard,
          meta: { requiresAuth: true },
        },

        // Company Info
        {
          path: '/companyinfo',
          redirect: '/companyinfo/registration',
          name: 'Company Info',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'registration',
              name: 'Company Registration',
              component: Registration,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[1].view === true){
                var reg_view = store.state.reg_view
                var reg_rights = store.state.reg_rights
                if (reg_view === true || reg_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/Companyinfo/Shop',
              name: 'Shop Details',
              component: Shop,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[2].view === true){
                var shop_view = store.state.shop_view
                var shop_rights = store.state.shop_rights
                if (shop_view === true || shop_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
          ]
        },

        // Define Security
        {
          path: '/definesecurity',
          redirect: '/definesecurity/user',
          name: 'Define Security',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'user',
              name: 'Add & Update User',
              component: User,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[3].view === true){
                var u_view = store.state.u_view
                var u_rights = store.state.u_rights
                if (u_view === true || u_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/Definesecurity/Role',
              name: 'Add & Update Role',
              component: Role,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[4].view === true){
                var r_view = store.state.r_view
                var r_rights = store.state.r_rights
                // var r_view = true
                if (r_view === true || r_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
          ]
        },

        // Help
        {
          path: '/help',
          name: 'Help',
          component: Help,
          meta: { requiresAuth: true },
        },

        // Purchase
        {
          path: '/purchase',
          redirect: '/purchase/purchaseentry',
          name: 'Purchase',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'Addpurches',
              name: 'Add Purchase',
              component: addpurches,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[11].rights === true){
                var pur_rights = store.state.pur_rights
                // var pur_rights = true
                if (pur_rights === true) {
                  next()

                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'editpurchase',
              name: 'Edit Purchase',
              component: editpurchase,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[11].rights === true){
                var pur_rights = store.state.pur_rights
                // var pur_rights = true
                if (pur_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'purchaseentry',
              name: 'Purchase Entry',
              component: Listpurches,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[11].view === true){
                var pur_view = store.state.pur_view
                var pur_rights = store.state.pur_rights
                if (pur_view === true || pur_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'Listpurchesreturn',
              name: 'List Purchase Return',
              component: Listpurchesreturn,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[12].view === true){
                var purrt_view = store.state.purrt_view
                var purrt_rights = store.state.purrt_rights
                if (purrt_view === true || purrt_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'Addpurchesreturn',
              name: 'Add Purchase return',
              component: Addpurchesreturn,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[12].rights === true){
                var purrt_rights = store.state.purrt_rights
                // var purrt_rights = true
                if (purrt_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'editpurchasereturn',
              name: 'Edit Purchase Return',
              component: editpurchasereturn,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[11].rights === true){
                var purrt_rights = store.state.purrt_rights
                // var purrt_rights = true
                if (purrt_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'supplier/add',
              name: 'Add & Update Supplier',
              component: AddSupplier,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[13].view === true){
                var sup_view = store.state.sup_view
                var sup_rights = store.state.sup_rights
                if (sup_view === true || sup_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'addpayment',
              name: 'Purchase Payment',
              component: addpayment,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[14].rights === true){
                var purpay_rights = store.state.purpay_rights
                // var purpay_rights = true
                if (purpay_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/purchase/listpayment',
              name: 'List Payment',
              component: purchase_payment_history,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[15].view === true){
                var purpayhis_view = store.state.purpayhis_view
                var purpayhis_rights = store.state.purpayhis_rights
                if (purpayhis_view === true || purpayhis_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/purchase/PurchaseReturnpayment',
              name: 'List Purchase Return Payment',
              component: purchasereturn_pending_list,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[15].view === true){
                // var purpayhis_view = store.state.purpayhis_view
                // var purpayhis_rights = store.state.purpayhis_rights
                var purchasert_v = store.state.purchasereturnpay_view
                var purchasert_r = store.state.purchasereturnpay_rights
                if (purchasert_v === true || purchasert_r === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
          ]
        },

        // Sales
        {
          path: '/sales',
          redirect: '/sales/salesentry',
          name: 'Sales',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/sales/salesentry',
              name: 'Sales Entry',
              component: sales,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[5].view === true){
                var sale_view = store.state.sale_view
                var sale_rights = store.state.sale_rights
                if (sale_view === true || sale_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/sales/addsales',
              name: 'Add Sales',
              component: addsales,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[5].rights === true){
                var sale_rights = store.state.sale_rights
                // var sale_rights = true
                if (sale_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/sales/editsales',
              name: 'Edit Sales',
              component: editsales,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[5].rights === true){
                var sale_rights = store.state.sale_rights
                // var sale_rights = true
                if (sale_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Sales Return',
              path: '/Salesreturn/list',
              component: ListSalesrt,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[6].view === true){
                var salert_view = store.state.salert_view
                var salert_rights = store.state.salert_rights
                if (salert_view === true || salert_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Edit Sales Return',
              path: 'editsalesreturn',
              component: editsalesreturn,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[6].rights === true){

                var salert_rights = store.state.salert_rights
                // var salert_rights = true
                if (salert_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Add Sales Return',
              path: '/Sales/Salesreturn',
              component: salesreturn,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[6].rights === true){
                var salert_rights = store.state.salert_rights
                // var salert_rights = true
                if (salert_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/Sales/customeradd',
              name: 'Add & Update Customer',
              component: Customer,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[7].view === true){
                var cust_view = store.state.cust_view
                var cust_rights = store.state.cust_rights
                if (cust_view === true || cust_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Sale Invoice',
              path: '/sales/saleinvoice/list',
              component: saleinvoice,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[8].view === true){
                var saleinvoice_view = store.state.saleinvoice_view
                var saleinvoice_rights = store.state.saleinvoice_rights
                if (saleinvoice_view === true || saleinvoice_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            // {
            //   name: 'Sale Invoice Pdf',
            //   path: '/saleinvoice/saleinvoicepdf',
            //   component:salepdf,

            //   meta: { requiresAuth: true },
            //   beforeEnter: (to, from, next) => {
            //     // var roles = JSON.parse(localStorage.getItem('roles'))
            //     // if(roles[8].view === true){
            //     var saleinvoice_view = store.state.saleinvoice_view
            //     if(saleinvoice_view === true){
            //       next()
            //     }else{
            //       next('/dashboard');
            //     }
            //   },
            //},
            {
              name: 'Sale Receipt',
              path: '/sales/salereceipt',
              component: salepayment,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[9].rights === true){
                var salerec_rights = store.state.salerec_rights
                // var salerec_view = true
                if (salerec_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Sales Receipt History',
              path: '/sales/Salesreceipthistory',
              component: salepaymenthistory,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[10].view === true){
                var salerechis_view = store.state.salerechis_view
                var salerechis_rights = store.state.salerechis_rights
                if (salerechis_view === true || salerechis_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              name: 'Sales Return Receipt History',
              path: '/sales/SalesReturnreceipthistory',
              component: salereturnpayment,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var salereturnpayment_view = store.state.salereturnpay_view
                var salereturnpayment_rights = store.state.salereturnpay_rights
                // console.log(salereturnpayment_view + '  ' + salereturnpayment_rights )
                // var salerechis_view = store.state.salerechis_view
                // var salerechis_rights = store.state.salerechis_rights
                // if (salerechis_view === true || salerechis_rights === true)
                if (salereturnpayment_view === true || salereturnpayment_rights === true) 
                {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            }
          ]
        },

        // ShopInventory
        {
          path: '/shopinventory',
          name: 'Shop Inventory',
          component: ShopInventory,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            // var roles = JSON.parse(localStorage.getItem('roles'))
            // if(roles[16].view === true){
            var invt_view = store.state.invt_view
            var invt_rights = store.state.invt_rights
            if (invt_view === true || invt_rights === true) {
              next()
            } else {
              next('/dashboard');
            }
          },
        },

        {
          path: '/CompaniesInfo',
          name: 'Companies Info',
          component: company_mgmt,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            var is_admin = store.state.is_admin
            // var invt_view = true
            if (is_admin === true) {
              next()
            } else {
              next('/dashboard');
            }
          },
        },

        {
          path: '/PlanConfig',
          name: 'Plan Config',
          component: plan_config,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            var is_admin = store.state.is_admin
            // var invt_view = true
            if (is_admin === true) {
              next()
            } else {
              next('/dashboard');
            }
          },
        },

        // {
        //   path: '/UserManagement',
        //   name: 'User Management',
        //   component: user_management,
        //   meta: { requiresAuth: true },
        //   beforeEnter: (to, from, next) => {
        //     var is_admin = store.state.is_admin
        //     // var invt_view = true
        //     if (is_admin === true) {
        //       next()
        //     } else {
        //       next('/');
        //     }
        //   },
        // },

        {
          path: '/user_management',
          redirect: '/user_management/user_info',
          name: 'User Management',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'user_info',
              name: 'User Info',
              component: user_info,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var is_admin = store.state.is_admin
                if (is_admin === true) {
                  next()
                }
                else {
                  next('/dashboard');
                }
              },
            },
            {
              path: 'user_status',
              name: 'User Status',
              component: user_status,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var is_admin = store.state.is_admin
                if (is_admin === true) {
                  next()
                }
                else {
                  next('/dashboard');
                }
              },
            }
          ]
        },

        // Transfer
        {
          path: '/stocktransfer',
          name: 'Stock Transfer',
          component: Listtransfer,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            // var roles = JSON.parse(localStorage.getItem('roles'))
            // if(roles[17].view === true){
            var stcktran_view = store.state.stcktran_view
            var stcktran_rights = store.state.stcktran_rights
            if (stcktran_view === true || stcktran_rights === true) {
              next()
            } else {
              next('/dashboard');
            }
          },
        },
        {
          path: '/addtransfer',
          name: 'Add Transfer',
          component: addtransfer,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            // var roles = JSON.parse(localStorage.getItem('roles'))
            // if(roles[17].rights === true){
            var stcktran_rights = store.state.stcktran_rights
            // var stcktran_rights = true
            if (stcktran_rights === true) {
              next()
            } else {
              next('/dashboard');
            }
          },
        },

        //Reports
        {
          path: '/reports',
          redirect: '/reports/balance_receipt_list',
          name: 'Reports',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/reports/balance_receipt_list',
              name: 'Balance Receipy List',
              component: pending_payment_cust_list,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var sale_view = store.state.sale_view
                if (sale_view === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            },
            {
              path: '/reports/pending_payment_list',
              name: 'Pending Payment List',
              component: pending_payment_supp_list,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var pur_view = store.state.pur_view
                if (pur_view === true) {
                  next()
                } else {
                  next('/dashboard');
                }
              },
            }
          ]
        },

        // Setup
        {
          path: '/setup',
          redirect: '/setup/addupdateproduct',
          name: 'Setup',
          meta: { requiresAuth: true },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'addupdateproduct',
              name: 'Add & Update Product',
              component: addproduct,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var prod_view = store.state.prod_view
                var prod_rights = store.state.prod_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                //   next()
                // }
                // else{
                if (prod_view === true || prod_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            },
            {
              path: 'barcode',
              name: 'Print Barcode',
              component: barcode,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                var prod_view = store.state.prod_view
                var prod_rights = store.state.prod_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                //   next()                }
                // else{
                if (prod_view === true || prod_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            },
            {
              path: 'addupdatecategory',
              name: 'Add & Update Category',
              component: Category,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[19].view === true){
                var cat_view = store.state.cat_view
                var cat_rights = store.state.cat_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                //   next()
                // }
                // else{
                if (cat_view === true || cat_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            },
            {
              path: 'addupdatebrand',
              name: 'Add & Update Brand',
              component: Brand,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[20].view === true){
                var brand_view = store.state.brand_view
                var brand_rights = store.state.brand_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                // store.state.brand_view = true
                // store.state.brand_rights = true
                // next()
                // }
                // else{
                if (brand_view === true || brand_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            },
            {
              path: '/taxdetails',
              name: 'Tax Details',
              redirect: '/setup/taxdetails/hsn',
              meta: { requiresAuth: true },
              component: {
                render(d) { return d('router-view') }
              },
              children: [
                {
                  path: '/setup/taxdetails/hsn',
                  name: 'Hsn',
                  component: hsn,
                  meta: { requiresAuth: true },
                  beforeEnter: (to, from, next) => {
                    var hsn_view = store.state.hsn_view
                    var hsn_rights = store.state.hsn_rights
                    if (hsn_view === true || hsn_rights === true) {
                      next()
                    } else {
                      next('/dashboard');
                    }
                  },
                },
                {
                  path: '/setup/taxdetails/hsnrate',
                  name: 'Hsn Rate',
                  component: hsnrate,
                  meta: { requiresAuth: true },
                  beforeEnter: (to, from, next) => {
                    // var roles = JSON.parse(localStorage.getItem('roles'))
                    // if(roles[21].view === true){
                    var tax_view = store.state.tax_view
                    var tax_rights = store.state.tax_rights
                    // var is_admin = store.state.is_admin
                    // if(is_admin === true){
                    // store.state.tax_view = true
                    // store.state.tax_rights = true
                    // next()
                    // }
                    // else{
                    if (tax_view === true || tax_rights === true) {
                      next()
                    } else {
                      next('/dashboard');
                    }
                    // }
                  }
                }
              ]
            },
            {
              path: '/setup/addupdatevariant',
              name: 'Add & Update Variant',
              component: variant,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[23].view === true){
                var var_view = store.state.var_view
                var var_rights = store.state.var_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                //   next()
                // }
                // else{
                if (var_view === true || var_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            },
            {
              path: '/setup/addupdateunit',
              name: 'Add & Update Unit',
              component: unit,
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                // var roles = JSON.parse(localStorage.getItem('roles'))
                // if(roles[24].view === true){
                var unit_view = store.state.unit_view
                var unit_rights = store.state.unit_rights
                // var is_admin = store.state.is_admin
                // if(is_admin === true){
                //   next()
                // }
                // else{
                if (unit_view === true || unit_rights === true) {
                  next()
                } else {
                  next('/dashboard');
                }
                // }
              },
            }
          ]
        },
      ],
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js